import React from 'react';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const ThemeFourFooter = ({ operator }) => {
	if (!operator) return null;

	const {
		operator_name: operatorName,
		color_codes: { footer_color: background } = {},
		footer_logo,
		footer_logo_width,
		phone_number,
		show_bottom_footer,
	} = operator;

	const getLink = () => {
		switch (operatorName) {
			case 'pullmandelsur':
				return { fb: '', insta: 'https://www.instagram.com/pullmandelsur.cl/' };
			case 'saopaulo':
				return {
					fb: 'https://www.facebook.com/busessaopaulo',
					insta: 'https://www.instagram.com/buses.sao.paulo/',
				};
			case 'santajuana':
				return {
					fb: 'https://www.facebook.com/share/e2oWZgDus1RzB2Ea/?mibextid=qi2Omg',
					insta: 'https://www.instagram.com/transportessantajuana/',
				};
			case 'losnavegadores':
				return {
					fb: 'https://www.facebook.com/buseslosnavegadores/',
					insta: 'https://www.instagram.com/los_navegadoressur/',
				};
			case 'chilebus':
				return { fb: '', insta: 'https://www.instagram.com/chilebus.cl/' };
			default:
				return {};
		}
	};

	const links = getLink();

	return (
		<div className="themes-theme-four-footer">
			<div className="footer-arc" style={{ background }}>
				<div className="footer-container new-container">
					<div>
						<a href="/">
							<img
								src={footer_logo || ''}
								alt=""
								style={{ width: footer_logo_width || '', height: 'auto' }}
							/>
						</a>
					</div>
					{/* <div className="footer-links">
						{links.fb && getIcons('fb', operator) && (
							<a href={links.fb} target="_blank" rel="noopener noreferrer">
								<img
									src={getIcons('fb', operator)}
									alt="Facebook"
									style={{ width: 20 }}
									className="footer-icon fb"
								/>
							</a>
						)}
						{links.insta && (
							<a href={links.insta} target="_blank" rel="noopener noreferrer">
								<img
									src={getIcons('insta', operator)}
									alt="Instagram"
									className="footer-icon insta"
								/>
							</a>
						)}
						{' | '}
						<img
							src={getIcons('phone', operator)}
							className="footer-icon phone-icon"
							alt="Phone"
						/>
						{phone_number && (
							<div className="phone">
								{operatorName === 'santajuana' ? '(+569) 99217771' : phone_number}
							</div>
						)}
					</div> */}
					<div className="footer-links">
						{links.fb && getIcons('fb', operator) && (
							<a href={links.fb} target="_blank" rel="noopener noreferrer">
								<img
									src={getIcons('fb', operator)}
									alt="Facebook"
									style={{ width: 20 }}
									className="footer-icon fb"
								/>
							</a>
						)}
						{links.insta && (
							<a href={links.insta} target="_blank" rel="noopener noreferrer">
								<img
									src={getIcons('insta', operator)}
									alt="Instagram"
									className="footer-icon insta"
								/>
							</a>
						)}
						{' | '}

						{operator && operator.operator_name === 'losnavegadores' ? (
							<div className='font10'>
								<a
									href="/terms"
									target="_blank"
									rel="noopener noreferrer"
									style={{
										color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
									}}
								>
									&nbsp;	Términos y Condiciones
								</a>
								{' | '}
								<a
									href="/privacy-policy"
									target="_blank"
									rel="noopener noreferrer"
									style={{
										color: operator && operator.color_codes && operator.color_codes.secondary_text_color,
									}}
								>
									Políticas de privacidad
								</a>
							</div>

						) : (
							<div>
								<img
									src={getIcons('phone', operator)}
									className="footer-icon phone-icon"
									alt="Phone"
								/>
								{phone_number && (
									<div className="phone">
										{operatorName === 'santajuana' ? '(+569) 99217771' : phone_number}
									</div>
								)}
							</div>
						)}
					</div>

				</div>
			</div>
			{show_bottom_footer && <ShowBottomFooter operator={operator} />}
		</div>
	);
};

const ShowBottomFooter = ({ operator }) => {
	const {
		operator_name,
		color_codes: { button_color, sub_footer_color, secondary_text_color: color } = {},
		name,
	} = operator;

	const background =
		operator_name === 'santajuana' ? button_color : sub_footer_color;

	return (
		<div className="d-flex-c bottom p-2" style={{ background, color }}>
			<div>
				{operator_name === 'santajuana' ? (
					<span>Transportes Santa Juana SpA 2024 </span>
				) : (
					<span>
						{name} {new Date().getFullYear()}
					</span>
				)}
				<span> - Todos los derechos reservados © | Powered by</span>
				<a href="https://kupos.cl" target="_blank" rel="noopener noreferrer">
					<img
						src={getIcons('kuposLogo', operator)}
						className="footer-kupos-logo"
						alt="Kupos Logo"
					/>
				</a>
			</div>
		</div>
	);
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
	themes: state.themes,
	home: state.home,
});

export default connect(mapStateToProps)(ThemeFourFooter);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/common/ThemeFourFooter.js